/**
 * index.tsx
 * @author Lucas Fridez <lucas@fridez.dev>
 * @description Main file that contains the root of the WebApp
 * @created Mon Jun 04 2018 14:33:49 GMT+0200 (Europe de l’Ouest (heure d’été))
 * @copyright Lucas Fridez
 * @last-modified Mon Jun 04 2018 14:18:07 GMT+0200 (Europe de l’Ouest (heure d’été))
 */

import 'core-js/es6/map';
import 'core-js/es6/set';

// React
import * as React from 'react';
import * as ReactDOM from 'react-dom';

// Redux
import { Provider } from 'react-redux';

// Store
import { MainStore } from './app/stores/MainStore';

// Style
import './style.css';

// Utils
import './app/framework/utils/String';

// Component
import App from './app/App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <Provider store={MainStore.getStore()}>
    <App />
  </Provider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx